import React, { useMemo } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { ProgramResourcesPanel } from '../ProgramResources';
import type { ResourceOwner } from '../ProgramResources/useProgramResources';
import type { EditableUnit } from './useUnit';

// The resources section, owned by the unit; the add and edit dialogs are its child routes.
const UnitResourcesSection = () => {
  const unit = useOutletContext<EditableUnit>();
  const { programId } = useParams<{ programId: string }>();
  const owner = useMemo<ResourceOwner>(
    () => ({ modelClass: 'Unit', modelId: unit.id, programId: Number(programId) }),
    [programId, unit.id],
  );

  return <ProgramResourcesPanel owner={owner} title="Unit Resources" />;
};

export default UnitResourcesSection;
